const defaultFunctions = {
  family() {
    return 'creative,editorial';
  },
  license(searchParameters) {
    if (searchParameters.assettype === 'image') {
      return 'rf,rm';
    }
    if (searchParameters.assettype === 'film') {
      return 'rf,rr';
    }
    return undefined;
  },
  page() {
    return 1;
  },
  recency(searchParameters) {
    if (
      !searchParameters.assetfamily ||
      searchParameters.assetfamily === 'editorial'
    ) {
      return 'anydate';
    }
    return null;
  },
};

const setDefaults = (searchParameters, availableSearchParameters) => {
  const newSearchParameters = { ...searchParameters };
  Object.keys(defaultFunctions).forEach((key) => {
    const value = searchParameters[key];
    const isUndefined = typeof value === 'undefined' || value === null;
    const isAvailable = !!availableSearchParameters[key];
    if (isUndefined && isAvailable) {
      const defaultFunction = defaultFunctions[key];
      const defaultValue = defaultFunction(searchParameters);
      newSearchParameters[key] = defaultValue;
    }
  });
  return newSearchParameters;
};

export default setDefaults;
